import { render, staticRenderFns } from "./ShippingPaymentMethodSetting.vue?vue&type=template&id=58094c5f&scoped=true&"
import script from "./ShippingPaymentMethodSetting.vue?vue&type=script&lang=js&"
export * from "./ShippingPaymentMethodSetting.vue?vue&type=script&lang=js&"
import style0 from "./ShippingPaymentMethodSetting.vue?vue&type=style&index=0&id=58094c5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58094c5f",
  null
  
)

export default component.exports